<script>
import appConfig from "@/app.config.json";
import Layout from "@/views/layouts/main.vue";
import Input from "@/mixins/inquiries/input";
import DatePicker from "vue2-datepicker";
import CommonTableComponent from "@/components/table.vue";
import ModalInquiryDetail from "@/views/pages/inquiries/modals/ModalInquiryDetail.vue";

export default {
  name: "inquiries.input",
  page: {
    title: "お問合せ",
    meta: [{name: "description", content: appConfig.description}]
  },
  mixins: [Input],
  components: {
    Layout,
    DatePicker,
    CommonTableComponent,
    ModalInquiryDetail
  },
  data() {
    return {
      headers: [
        {
          text: "NO",
        },
        {
          text: "事業者",
          value: "discharger_name_abbreviated",
          sortable: true,
        },
        {
          text: "事業場",
          value: "discharger_site_name_abbreviated",
          sortable: true,
        },
        {
          text: "問合せ日",
          value: "created_at",
          sortable: true,
        },
        {
          text: "種類",
          value: "inquiry_type",
          sortable: true,
        },
        {
          text: "タイトル",
          value: "title",
          sortable: true,
        },
        {
          text: "状態",
          value: "inquiry_status",
          sortable: true,
        },
        {
          text: "最終対応日",
          value: "submit_at",
          sortable: true,
        }
      ]
    };
  }
}
</script>
<template>
  <Layout>
    <ModalInquiryDetail
      ref="inquiryDetail"
      @onAnswered="onAnswered"
    />
    <b-card class="mb-1">
      <b-row>
        <div class="col-md-4">
          <div class="d-flex mb-2">
            <label class="col-form-label text-nowrap me-2 mw-130" for="business-person-input">事業者</label>
            <b-form-input
              id="business-person-input"
              v-model="filters.discharger_name_abbreviated"
              type="text"
            />
          </div>
        </div>
        <div class="col-md-4">
          <div class="d-flex mb-2">
            <label class="col-form-label text-nowrap me-2" for="workplace-input">事業場</label>
            <b-form-input
              id="workplace-input"
              v-model="filters.discharger_site_name_abbreviated"
              type="text"
            />
          </div>
        </div>
      </b-row>
      <b-row>
        <div class="col-md-4">
          <div class="d-flex mb-2">
            <label class="col-form-label text-nowrap me-2 mw-130" for="inquiry-type">問合せ種類</label>
            <b-form-select
              id="inquiry-type"
              v-model="filters.zz_inquiry_type_id"
              :options="inquiryTypes"
              value-field="id"
              text-field="inquiry_type"
              class="form-select custom-select"
            ></b-form-select>
          </div>
        </div>
      </b-row>
      <b-row>
        <div class="col-md-4">
          <div class="d-flex mb-2">
            <label class="col-form-label text-nowrap me-2 mw-130">問合せ日</label>
            <date-picker
              lang="ja"
              v-model="filters.start_datetime"
              placeholder="YYYY-MM-DD"
              format="YYYY-MM-DD"
              value-type="YYYY-MM-DD"
              position="left"
              class="manifests-date-picker"
            ></date-picker>
            <div class="align-self-center m-2">～</div>
            <date-picker
              lang="ja"
              v-model="filters.end_datetime"
              placeholder="YYYY-MM-DD"
              format="YYYY-MM-DD"
              value-type="YYYY-MM-DD"
              position="right"
              class="manifests-date-picker"
            ></date-picker>
          </div>
        </div>
      </b-row>
      <b-row>
        <div class="col-md-4">
          <div class="d-flex mb-2">
            <label class="col-form-label text-nowrap me-2 mw-130">解決済みも表示する</label>
            <b-form-checkbox
              style="margin-top: 9px;"
              v-model="filters.zz_inquiry_status_id"
              :value="3"
            />
          </div>
        </div>
      </b-row>
      <b-row>
        <div class="d-flex justify-content-center align-items-center">
          <b-button size="lg" variant="primary" @click="onSearch()" class="me-2">
            <div class="d-flex align-items-center justify-content-center">
              <i class="fas fa-search"></i> {{ this.$lang.button.search }}
            </div>
          </b-button>
          <b-button size="lg" variant="dark" class="me-2" @click="onClearFilters()">
            <i class="fas fa-eraser"></i> {{ this.$lang.button.clear }}
          </b-button>
        </div>
      </b-row>
    </b-card>
    <b-card>
      <b-overlay
        :show="isLoading"
        rounded
        opacity="0.6"
        spinner-small
        spinner-variant="primary"
        class="d-inline-block w-100"
      >
        <CommonTableComponent :height-class="`table-wrapper-500`">
          <thead class="table-light">
            <tr>
              <th
                v-for="(item, index) in headers"
                :key="index"
                :class="[...getHeaderClass(item), 'text-center']"
              >
                <span v-if="item.sortable" @click="clickSort(item.value)">
                  <span v-html="item.text"></span>
                  <i :class="getSortClass(item.value)"></i>
                </span>
                <span v-else v-html="item.text"> </span>
              </th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(inquiry, index) in inquiries">
              <tr class="cursor-pointer" @click="openinQuiryDetailModal(inquiry)">
                <td>{{ index+1 }}</td>
                <td>{{ inquiry.discharger_name_abbreviated }}</td>
                <td>{{ inquiry.discharger_site_name_abbreviated }}</td>
                <td>{{ inquiry.created_at }}</td>
                <td>{{ inquiry.inquiry_type }}</td>
                <td>{{ inquiry.title }}</td>
                <td>{{ inquiry.inquiry_status }}</td>
                <td>{{ inquiry.submit_at }}</td>
              </tr>
            </template>
            <template v-if="!inquiries.length">
              <tr>
                <td :colspan="headers.length" class="text-center">
                  データなし。
                </td>
              </tr>
            </template>
          </tbody>
        </CommonTableComponent>
      </b-overlay>
      <div
          class="d-flex justify-content-between mt-3"
          v-if="meta.total && Object.keys(meta).length"
        >
          <div class="d-flex align-items-center">
            <b-pagination
              v-model="filters.page"
              :total-rows="meta.total"
              :per-page="meta.per_page"
            ></b-pagination>
          </div>
          <div class="d-flex align-items-center">
            <div class="me-2">
              {{ meta.from }} - {{ meta.to }} / {{ meta.total }}
            </div>
          </div>
        </div>
    </b-card>
  </Layout>
</template>
